import React from "react";

import { Select, CategoriesAvatar } from "@aclymatepackages/atoms";
import { subcategoriesWithColors } from "@aclymatepackages/subcategories";

const EmissionsCategorySelect = ({
  value = "",
  setValue,
  size = "small",
  label = "Select an emissions category",
  multiple,
  disabled,
  additionalSubcategories = [],
  availableSubcategories,
}) => {
  const filteredSubcategories = subcategoriesWithColors.filter(
    ({ tags = [] }) => tags.includes("vendors")
  );

  const options = (availableSubcategories || filteredSubcategories).map(
    ({ name, subcategory, color }) => {
      return {
        label: name,
        value: subcategory,
        avatar: <CategoriesAvatar size="small" subcategory={subcategory} />,
        style: { backgroundColor: color, color: "white" },
      };
    }
  );

  const deduplicatedSetValue = (updater) => {
    const deduplicateByValue = (arr) =>
      arr.filter(
        (item, idx, self) =>
          self.findIndex(({ value }) => value === item.value) === idx
      );

    if (typeof updater === "function") {
      return setValue((prev) => deduplicateByValue(updater(prev)));
    }

    return setValue(deduplicateByValue(updater));
  };

  return (
    <Select
      label={label}
      options={[...options, ...additionalSubcategories]}
      value={value}
      editValue={multiple ? deduplicatedSetValue : setValue}
      size={size}
      valueAvatar={<CategoriesAvatar size="small" subcategory={value} />}
      multiple={multiple}
      labelWidth={250}
      style={{ minWidth: "200px" }}
      disabled={disabled}
    />
  );
};
export default EmissionsCategorySelect;
